export default "__VITE_ASSET__BNb2T0br__$_?nuxt_component=async&nuxt_component_name=IconGtLogo&nuxt_component_export=default__"